
const PasosDetallados = () => {
  const pasos = [
    {
      numero: 1,
      titulo: 'Contacta con Desguace Gavá',
      descripcion: 'El primer paso es ponerte en contacto con nosotros. Puedes llamarnos al 936 622 445 o escribirnos por WhatsApp. Te atendemos de inmediato, sin esperas.',
      detalles: [
        'Horario de atención: Lunes a Viernes de 9:00 a 19:00h',
        'Respuesta inmediata por WhatsApp',
        'Atención personalizada y profesional',
        'Sin compromiso ni costes ocultos',
      ],
      icon: 'ri-phone-fill',
      color: 'emerald',
    },
    {
      numero: 2,
      titulo: 'Proporciona Información del Vehículo',
      descripcion: 'Necesitamos conocer algunos datos básicos de tu coche para poder hacer una valoración precisa. Cuanta más información nos des, más exacta será nuestra oferta.',
      detalles: [
        'Marca, modelo y año de fabricación',
        'Kilómetros recorridos',
        'Estado general y tipo de daños',
        'Fotos del vehículo (opcional pero recomendado)',
      ],
      icon: 'ri-car-fill',
      color: 'emerald',
    },
    {
      numero: 3,
      titulo: 'Recibe tu Valoración Gratuita',
      descripcion: 'En menos de 2 horas te enviamos una oferta económica sin compromiso. Nuestra valoración es justa, transparente y basada en el precio real de mercado en Gavá.',
      detalles: [
        'Valoración gratuita y sin compromiso',
        'Respuesta en menos de 2 horas',
        'Precio competitivo y transparente',
        'Asesoramiento profesional incluido',
      ],
      icon: 'ri-price-tag-3-fill',
      color: 'emerald',
    },
    {
      numero: 4,
      titulo: 'Acepta la Oferta y Agenda la Recogida',
      descripcion: 'Si estás de acuerdo con nuestra oferta, acordamos día y hora para recoger tu vehículo en Gavá. Nos adaptamos a tu disponibilidad y nos desplazamos a donde esté el coche.',
      detalles: [
        'Recogida en 24-48 horas',
        'Servicio de grúa incluido sin coste',
        'Nos desplazamos a Gavá y alrededores',
        'Flexibilidad horaria',
      ],
      icon: 'ri-calendar-check-fill',
      color: 'emerald',
    },
    {
      numero: 5,
      titulo: 'Prepara la Documentación',
      descripcion: 'Para completar la venta necesitarás tener preparados algunos documentos básicos. No te preocupes, nosotros nos encargamos de todos los trámites administrativos posteriores.',
      detalles: [
        'DNI o NIE del titular del vehículo',
        'Permiso de circulación original',
        'Ficha técnica del vehículo',
        'Último recibo del seguro (opcional)',
      ],
      icon: 'ri-file-text-fill',
      color: 'emerald',
    },
    {
      numero: 6,
      titulo: 'Recibe el Pago Inmediato',
      descripcion: 'En el momento de la recogida del vehículo recibes el pago acordado. Sin esperas, sin trámites bancarios complicados. Tú eliges: efectivo o transferencia instantánea.',
      detalles: [
        'Pago al momento de la recogida',
        'Efectivo o transferencia bancaria',
        'Sin esperas ni demoras',
        'Comprobante de pago inmediato',
      ],
      icon: 'ri-money-euro-circle-fill',
      color: 'emerald',
    },
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Pasos para Vender tu Coche en <strong>Gavá</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Proceso sencillo y transparente para vender tu coche siniestrado o averiado. En 6 pasos tendrás el dinero en tu cuenta
          </p>
        </div>

        <div className="space-y-12">
          {pasos.map((paso, index) => (
            <div key={index} className="relative">
              {index < pasos.length - 1 && (
                <div className="hidden md:block absolute left-8 top-20 bottom-0 w-0.5 bg-emerald-200"></div>
              )}
              <div className="flex flex-col md:flex-row gap-6 items-start">
                <div className="flex-shrink-0 relative z-10">
                  <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center shadow-lg">
                    <i className={`${paso.icon} text-white text-2xl`}></i>
                  </div>
                </div>
                <div className="flex-1 bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all">
                  <div className="flex items-center space-x-3 mb-4">
                    <span className="text-4xl font-bold text-emerald-600">0{paso.numero}</span>
                    <h3 className="text-2xl font-bold text-gray-900">
                      <strong>{paso.titulo}</strong>
                    </h3>
                  </div>
                  <p className="text-gray-600 mb-6 leading-relaxed text-lg">
                    {paso.descripcion}
                  </p>
                  <ul className="space-y-3">
                    {paso.detalles.map((detalle, idx) => (
                      <li key={idx} className="flex items-start space-x-3">
                        <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mt-0.5"></i>
                        <span className="text-gray-700">{detalle}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PasosDetallados;
